export default "__VITE_ASSET__RV78bBm6__"